<template>
	<div>
		<sub-header bizCd="05"/>
		<div class="sub_visual sub08">
			<div class="container">
				<div class="sub_txt">
					<div class="tit">교육 협약</div>
					<div class="comment">에듀윌은 공공기관, 기업 등 단체와의 교육 협약을 통해<br>
						구성원의 성장과 성공적인 미래를 약속합니다.
					</div>
				</div>
			</div>
		</div>
		<div class="contents aos-all">
			<div class="container">
				<div class="sec none-padding">
					<div class="sub_tit">기업·기관·단체 협약</div>
					<div class="con">
						<div class="txt">단체와의 교육 협약으로 특별 혜택을 제공함으로써 소속 구성원의 성장과 함께 만족도가 향상됩니다.</div>
						<div class="banner_wrapper pc840hidden">
							<div class="img_3depth">
								<div class="ba_img"><img
									src="//img.eduwill.net/resources/b2b/dev/images/agreement-01.png" alt="KT"/></div>
								<div class="ba_img"><img
									src="//img.eduwill.net/resources/b2b/dev/images/agreement-02.png" alt="육군본부"/></div>
								<div class="ba_img"><img
									src="//img.eduwill.net/resources/b2b/dev/images/agreement-03.png" alt="숭실사이버대"/>
								</div>
							</div>
						</div>
						<div class="responsive_slider mobile840hidden">
							<div class="swiper-container img-role">
								<div class="swiper-wrapper">
									<div class="swiper-slide"><img
										src="//img.eduwill.net/resources/b2b/dev/images/agreement-01@3x.png"></div>
									<div class="swiper-slide"><img
										src="//img.eduwill.net/resources/b2b/dev/images/agreement-02@3x.png"></div>
									<div class="swiper-slide"><img
										src="//img.eduwill.net/resources/b2b/dev/images/agreement-03@3x.png"></div>
								</div>
								
								<div class="swiper-pagination"></div>
								<div class="vi-button swiper-button-next"></div>
								<div class="vi-button swiper-button-prev"></div>
							
							</div>
						</div>
					</div>
				</div>
				<div class="sec none-padding">
					<div class="sub_tit">대학 취업교육 협약</div>
					<div class="con">
						<div class="txt">수많은 대학과의 취업교육 협약을 통해 재학생의 취업 진출에 힘쓰고 있습니다.</div>
						<div class="banner_wrapper pc840hidden">
							<div class="img_2depth">
								<div class="ba_img"><img
									src="//img.eduwill.net/resources/b2b/dev/images/img-college-01.png"
									alt="현장강의 20% 할인 적용"></div>
								<div class="ba_img"><img
									src="//img.eduwill.net/resources/b2b/dev/images/img-college-02.png"
									alt="에듀윌 취업 굿즈 5종 제공"></div>
							</div>
							<div class="img_3depth">
								<div class="ba_img"><img
									src="//img.eduwill.net/resources/b2b/dev/images/img-college-03.png" alt="패키지 상품"/>
								</div>
								<div class="ba_img"><img
									src="//img.eduwill.net/resources/b2b/dev/images/img-college-04.png"
									alt="VR 면접권 체험권 제공"/></div>
								<div class="ba_img"><img
									src="//img.eduwill.net/resources/b2b/dev/images/img-college-05.png" alt="AI면접특강"/>
								</div>
							</div>
						</div>
						<div class="responsive_slider mobile840hidden">
							<div class="swiper-container img-role">
								<div class="swiper-wrapper">
									<div class="swiper-slide"><img
										src="//img.eduwill.net/resources/b2b/dev/images/img-college-01-mo@3x.png"></div>
									<div class="swiper-slide"><img
										src="//img.eduwill.net/resources/b2b/dev/images/img-college-02-mo@3x.png"></div>
									<div class="swiper-slide"><img
										src="//img.eduwill.net/resources/b2b/dev/images/img-college-03-mo@3x.png"></div>
									<div class="swiper-slide"><img
										src="//img.eduwill.net/resources/b2b/dev/images/img-college-04-mo@3x.png"></div>
									<div class="swiper-slide"><img
										src="//img.eduwill.net/resources/b2b/dev/images/img-college-05-mo@3x.png"></div>
								</div>
								
								<div class="swiper-pagination"></div>
								<div class="vi-button swiper-button-next"></div>
								<div class="vi-button swiper-button-prev"></div>
							
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="ex_container">
                <div class="sec">
                    <div class="sub_tit">관련 보도 자료</div>
                    <div class="con">
                        <div class="txt">에듀윌-국립공주대, 재학생 교육 지원을 위한 업무 협약 체결</div>
                        <div class="message_wrap">
                            <div class="img_float">
                                <div class="video">
                                    <!-- <div class="control-box"
                                        onclick="$(this).hide().next('.video_play').show().find('video').get(0).play();">
                                        <img src="//img.eduwill.net/resources/b2b/dev/images/img-video-01.png">
                                        <div class="btn_play"><img
                                                src="//img.eduwill.net/resources/b2b/dev/images/play-button.png">
                                        </div>
                                    </div>
                                    <div class="video_play" style="display: none;">
                                        <video src="../video/ZA4-YSH-SAMPLE.mp4" controls=""></video></div> -->
                                    <iframe width="560" height="315" src="https://www.youtube.com/embed/SdNfuh5PcuQ"
                                        title="YouTube video player" frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                </div>

                            </div>
                            <div class="message_float">
                                <div class="common">
                                    <p>에듀윌이 지난 29일 서울 역삼동에 위치한 에듀윌 부동산아카데미 강남캠퍼스에서
                                        국립공주대학교 재학생들의 교육 지원을 위한 업무협약을 맺었다고 30일 밝혔다.</p>

                                    <p>이번 협약은 국립공주대학교 부동산학과 재학생들이 공인중개사 1위 에듀윌 부동산아카데미의 부동산 실무 교육 과정, 공인중개사를 비롯한 각종 자격증
                                        취득 과정과<br>
                                        공무원 교육 과정 등 에듀윌이 운영하고 있는 교육 과정 수강 시 수강료 할인 등의 혜택을 제공하는 것이
                                        골자다.</p>

                                    <p>에듀윌 심유순 본부장은 "사회 진출을 앞둔 대학생 여러분이 에듀윌을 통해 더 탄탄히 미래를 준비할 수 있도록 적극 지원할 예정이다.공주대
                                        부동산학과와의 협약을 시작으로 더 많은 학생들에게도 좋은 기회를 제공할 수 있도록 노력하겠다"고 말했다.</p>


                                </div>
                                <div class="tag">(한국경제TV, 2022-06-30 보도자료 발췌)</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
			<div class="sub_partner">
				<div class="container">
					<div class="title_line">
						<div class="pa_tit">Partner</div>
						<div class="text">에듀윌과 함께하는 교육 협약 제휴 파트너사입니다.</div>
					</div>
					<ul class="pa_slider_scroll">
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-01.png"/></li>
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-02.png"/></li>
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-03.png"/></li>
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-04.png"/></li>
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-07.png"/></li>
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-08.png"/></li>
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-27.png"/></li>
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-39.png"/></li>
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-125.png"/></li>
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-126.png"/></li>
					</ul>
				</div>
			</div>
		</div>
		<div class="float_counsel m_hidden">
        <div class="group-wrap">
            <div class="group">
                <div class="text">에듀윌과 함께<br>변화를 시작하세요.</div>
                <div class="button" @click="showCounsel('01')"><a href="javascript:;" @click="show_counsel('01')">맞춤상담신청</a></div>
                <div class="ico-hand"></div>
            </div>
        </div>
    </div>
    <div class="float_counsel_mobile pc_hidden">
		<a class="circle_counsel" @click="showCounsel('01')">맞춤<br>상담</a>
    </div>
	</div>
</template>

<script>
import SubHeader from "@/layouts/SubHeader";
import eventBus from "@/eventBus/event-bus";
export default {
	name: "ontentProviederEduSell",
	components: {SubHeader},
	data() {
		return {}
	},
	
	computed: {
	},
	
	methods: {
		showCounsel(v) {
			eventBus.$emit("show-counsel", v);
		},
		closeCurriculum(v) {
			$('.curriculum_pop_' + v).bPopup().close();
		},
		showCurriculum(v) {
			$('.curriculum_pop_' + v).bPopup();
		}
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
}
</script>

<style scoped>

</style>
